import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg p-3 shadow-lg border text-xs font-caption"
      style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}>
      <p className="font-semibold mb-1" style={{ color: "var(--color-foreground)" }}>{label}</p>
      {payload?.map((p) => (
        p?.value != null && (
          <p key={p?.name} style={{ color: p?.color }}>
            {p?.name}: ₹{p?.value}L
          </p>
        )
      ))}
    </div>
  );
};

export default function QuotaChart({ data: dataProp }) {
  const chartData = dataProp || [];
  const hasQuota = chartData.some((point) => point?.quota != null);

  return (
    <div
      className="card-base p-4 md:p-6"
      style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg" style={{ color: "var(--color-foreground)" }}>
            Quota vs Attainment
          </h3>
          <p className="text-xs font-caption mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            {hasQuota
              ? "Last 6 months · Team aggregate (₹L)"
              : "Last 6 months · Closed-won per month (₹L) — no quota targets set"}
          </p>
        </div>
        {hasQuota && (
          <div className="flex items-center gap-3 text-xs font-caption">
            <span className="flex items-center gap-1.5">
              <span className="w-3 h-3 rounded-sm inline-block" style={{ background: "#1E40AF" }} />
              <span style={{ color: "var(--color-text-secondary)" }}>Quota</span>
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-3 h-3 rounded-sm inline-block" style={{ background: "#10B981" }} />
              <span style={{ color: "var(--color-text-secondary)" }}>Attained</span>
            </span>
          </div>
        )}
      </div>
      <div className="w-full h-48 md:h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} barGap={4} barCategoryGap="30%">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11, fill: "var(--color-text-secondary)", fontFamily: "var(--font-caption)" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "var(--color-text-secondary)", fontFamily: "var(--font-data)" }} axisLine={false} tickLine={false} tickFormatter={v => `₹${v}L`} />
            <Tooltip content={<CustomTooltip />} />
            {hasQuota && <Bar dataKey="quota" name="Quota" fill="#1E40AF" radius={[4, 4, 0, 0]} opacity={0.7} />}
            <Bar dataKey="attained" name="Attained" fill="#10B981" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}